export default "__VITE_ASSET__5c6B6SEv__"